import { Navigate } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";

import DashboardsDefault from "views/admin/dashboards";
import EntriesAndExits from "views/admin/dashboards/entries-and-exits";
import People from "views/admin/people";
import ServiceScheduler from "views/admin/scheduler";
import SignIn from "views/auth/signin";
import VerificationDefault from "views/auth/verification";
import ForgotPasswordDefault from "views/auth/forgot-password";
import SetupNewPasswordDefault from "views/auth/setup-new-password";
import Occupancy from "views/admin/dashboards/occupancy";
import MemberLocation from "views/admin/member-location";
import Settings from "views/admin/settings";
import VolunteerServices from "views/volunteer/services";
import VolunteerServiceDetails from "views/volunteer/services/details";
import CheckIn from "views/member/check-in";
import CheckOut from "views/member/checkout";
import Registration from "views/member/register";
import PCIntegrationRedirecting from "views/admin/redirecting/pc-integration";
import ComingSoon from "components/comming-soon";
import ChurchInsights from "views/admin/ChurchInsights";
// import Organization from "views/admin/dashboards/organization";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    // user is not authenticated
    return <Navigate to="/auth/signin" replace />;
  }
  return children;
};

export const routes = [
  {
    name: "Dashboard",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 10L19 10M10 1L10 19M5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    layout: "/admin",
    path: "/dashboard",
    component: <DashboardsDefault />,
    collapse: true,
    items: [
      {
        name: "Details",
        title: "Entries and Exits",
        layout: "/admin",
        path: "/dashboard/entries-and-exits",
        component: <EntriesAndExits />,
        hideInSidebar: true,
      },
      {
        name: "Details",
        title: "Entries and Exits",
        layout: "/admin",
        path: "/dashboard/occupancy",
        component: <Occupancy />,
        hideInSidebar: true,
      },
    ],
  },
  {
    name: "Church Insights",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M8 7V17M12 11V17M16 15V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    path: "/church-insights",
    layout: "/admin",
    // component: <ComingSoon />,
    component: <ChurchInsights />,
  },
  {
    name: "People",
    title: "People management",
    path: "/people",
    icon: (
      <svg
        width="22"
        height="19"
        viewBox="0 0 22 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 1.46776C16.4817 2.20411 17.5 3.73314 17.5 5.5C17.5 7.26686 16.4817 8.79589 15 9.53224M17 14.7664C18.5115 15.4503 19.8725 16.565 21 18M1 18C2.94649 15.5226 5.58918 14 8.5 14C11.4108 14 14.0535 15.5226 16 18M13 5.5C13 7.98528 10.9853 10 8.5 10C6.01472 10 4 7.98528 4 5.5C4 3.01472 6.01472 1 8.5 1C10.9853 1 13 3.01472 13 5.5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    layout: "/admin",
    component: <People />,
    collapse: true,
    items: [
      {
        name: "Details",
        layout: "/admin",
        path: "/people/:id",
        component: <People />,
        hideInSidebar: true,
      },
      {
        name: "Edit Profile",
        layout: "/admin",
        path: "/people/:id/edit",
        component: <People />,
        hideInSidebar: true,
      },
    ],
  },
  {
    name: "Scheduling",
    title: "Service Scheduling",
    icon: (
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 9H1M14 1V5M6 1V5M8.5 13L10 12V17M8.75 17H11.25M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    path: "/service-scheduling",
    layout: "/admin",
    // component: <ComingSoon />,
    component: <ServiceScheduler />,
    collapse: true,
    items: [
      {
        name: "Service Details",
        layout: "/admin",
        path: "/service-scheduling/services/:id",
        component: <ServiceScheduler />,
        hideInSidebar: true,
      },
      {
        name: "Edit Service",
        layout: "/admin",
        path: "/service-scheduling/services/:id/edit",
        component: <ServiceScheduler />,
        hideInSidebar: true,
      },
    ],
  },
  // {
  //   name: "Organization",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       width="22"
  //       height="22"
  //       viewBox="0 0 22 22"
  //       fill="none"
  //     >
  //       <path
  //         d="M16 3.46776C17.4817 4.20411 18.5 5.73314 18.5 7.5C18.5 9.26686 17.4817 10.7959 16 11.5322M18 16.7664C19.5115 17.4503 20.8725 18.565 22 20M2 20C3.94649 17.5226 6.58918 16 9.5 16C12.4108 16 15.0535 17.5226 17 20M14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3C11.9853 3 14 5.01472 14 7.5Z"
  //         stroke="#91B9A8"
  //         stroke-width="2"
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //       />
  //     </svg>
  //   ),
  //   path: "/organization",
  //   layout: "/admin",
  //   component: <Organization />,
  // },
  {
    name: "Member Location",
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 17L1 21V5L8 1M8 17L15 21M8 17V1M15 21L21 17V1L15 5M15 21V5M15 5L8 1"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    path: "/member-location",
    layout: "/admin",
    // component: <ComingSoon />,
    component: <MemberLocation />,
  },
  {
    name: "Settings",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.39504 19.3711L9.97949 20.6856C10.1532 21.0768 10.4368 21.4093 10.7957 21.6426C11.1547 21.8759 11.5736 22.0001 12.0017 22C12.4298 22.0001 12.8488 21.8759 13.2077 21.6426C13.5667 21.4093 13.8502 21.0768 14.0239 20.6856L14.6084 19.3711C14.8164 18.9047 15.1664 18.5159 15.6084 18.26C16.0532 18.0034 16.5677 17.8941 17.0784 17.9478L18.5084 18.1C18.934 18.145 19.3636 18.0656 19.7451 17.8713C20.1265 17.6771 20.4434 17.3763 20.6573 17.0056C20.8714 16.635 20.9735 16.2103 20.951 15.7829C20.9285 15.3555 20.7825 14.9438 20.5306 14.5978L19.6839 13.4344C19.3825 13.0171 19.2214 12.5148 19.2239 12C19.2238 11.4866 19.3864 10.9864 19.6884 10.5711L20.535 9.40778C20.7869 9.06175 20.933 8.65007 20.9554 8.22267C20.9779 7.79528 20.8759 7.37054 20.6617 7C20.4478 6.62923 20.1309 6.32849 19.7495 6.13423C19.3681 5.93997 18.9385 5.86053 18.5128 5.90556L17.0828 6.05778C16.5722 6.11141 16.0576 6.00212 15.6128 5.74556C15.1699 5.48825 14.8199 5.09736 14.6128 4.62889L14.0239 3.31444C13.8502 2.92317 13.5667 2.59072 13.2077 2.3574C12.8488 2.12408 12.4298 1.99993 12.0017 2C11.5736 1.99993 11.1547 2.12408 10.7957 2.3574C10.4368 2.59072 10.1532 2.92317 9.97949 3.31444L9.39504 4.62889C9.18797 5.09736 8.83792 5.48825 8.39504 5.74556C7.95026 6.00212 7.43571 6.11141 6.92504 6.05778L5.4906 5.90556C5.06493 5.86053 4.63534 5.93997 4.25391 6.13423C3.87249 6.32849 3.55561 6.62923 3.34171 7C3.12753 7.37054 3.02549 7.79528 3.04798 8.22267C3.07046 8.65007 3.2165 9.06175 3.46838 9.40778L4.31504 10.5711C4.61698 10.9864 4.77958 11.4866 4.77949 12C4.77958 12.5134 4.61698 13.0137 4.31504 13.4289L3.46838 14.5922C3.2165 14.9382 3.07046 15.3499 3.04798 15.7773C3.02549 16.2047 3.12753 16.6295 3.34171 17C3.55582 17.3706 3.87274 17.6712 4.25411 17.8654C4.63548 18.0596 5.06496 18.1392 5.4906 18.0944L6.9206 17.9422C7.43127 17.8886 7.94581 17.9979 8.3906 18.2544C8.83513 18.511 9.18681 18.902 9.39504 19.3711Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9999 15C13.6568 15 14.9999 13.6569 14.9999 12C14.9999 10.3431 13.6568 9 11.9999 9C10.3431 9 8.99992 10.3431 8.99992 12C8.99992 13.6569 10.3431 15 11.9999 15Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    path: "/settings",
    layout: "/admin",
    component: <Settings />,
  },
  {
    name: "PC Integration Redirecting",
    icon: null,
    path: "/pc-integration-redirecting",
    layout: "/admin",
    hideInSidebar: true,
    component: <PCIntegrationRedirecting />,
  },
  {
    name: "Signin",
    layout: "/auth",
    path: "/signin",
    hideInSidebar: true,
    component: <SignIn />,
  },
  {
    name: "2FA",
    layout: "/auth",
    path: "/verification",
    hideInSidebar: true,
    component: <VerificationDefault />,
  },
  {
    name: "ForgotPassword",
    layout: "/auth",
    path: "/forgot-password",
    hideInSidebar: true,
    component: <ForgotPasswordDefault />,
  },
  {
    name: "ResetPassword",
    layout: "/auth",
    path: "/reset-password",
    hideInSidebar: true,
    component: <SetupNewPasswordDefault />,
  },
  {
    name: "Services",
    layout: "/volunteer",
    path: "/my-services",
    hideInSidebar: true,
    component: <VolunteerServices />,
  },
  {
    name: "Service Details",
    layout: "/volunteer",
    path: "/services/:id",
    hideInSidebar: true,
    component: <VolunteerServiceDetails />,
  },
  {
    name: "Check-in",
    layout: "/member",
    path: "/check-in",
    hideInSidebar: true,
    component: <CheckIn />,
  },
  {
    name: "Check-out QR Code",
    layout: "/member",
    path: "/check-out",
    hideInSidebar: true,
    component: <CheckOut />,
  },
  {
    name: "Registration",
    layout: "/member",
    path: "/register",
    hideInSidebar: true,
    component: <Registration />,
  },
];
